module.exports = __webpack_public_path__ + "img/total-6.6e5cdcf5.png";